import {
  Button,
  Card,
  Form,
  Result,
  Space,
  Spin,
  Tooltip,
  message
} from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory, useLocation } from 'react-router-dom';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import EmpresaContext from '../../context/empresa-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import PagosCartaVerdeForm from './PagosCartaVerdeForm';

const styles = {
  aceptoContainer: {
    textAlign: 'justify',
    paddingTop: 40,
    paddingBottom: 40
  },
  acepto: {
    width: '80%',
    fontSize: 12,
    textalign: 'justify',
    display: 'flex',
    alignItems: 'center'
  },
  list: {
    textAlign: 'left',
    maxWidth: 500,
    margin: 'auto',
    marginTop: 40
  },
  icon: { fontSize: 20 }
};

const GenerarPolizaCartaVerde = ({ ...props }) => {
  const [form] = Form.useForm();

  const { executeRecaptcha } = useGoogleReCaptcha();
  const myRef = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const [card, setCard] = useState();
  const [tokenForRequests, setTokenForRequests] = useState(null);

  const { updateProducto } = useContext(EmpresaContext);
  const [estado, setEstado] = useState();
  const [loading, setLoading] = useState(true);
  const [solicitando, setSolicitando] = useState(false);
  const [solicitud, setSolicitud] = useState();
  const [idClienteLastCard, setIdClienteLastCard] = useState();
  const [errorCatastro, setErrorCatastro] = useState();
  const [metodoPago, setMetodoPago] = useState();

  const solicitar = async (values) => {
    try {
      setLoading(true);
      setSolicitando(true);
      const { numeroCuenta } = values;
      const vencimientoTarjeta = card?.expiry;
      const numeroTarjeta = card?.number;
      const titularTarjeta = card?.name;
      const marcaTarjeta = card?.issuer ? card.issuer.toUpperCase() : '';
      const solicitudEnviar = {
        referencia: values.referencia,
        datosPago: {
          numeroTarjeta,
          titularTarjeta,
          vencimientoTarjeta,
          marcaTarjeta,
          numeroCuenta
        }
      };
      // if (solicitud?.metodoPago?.codigo === 'tarjeta' && card) {
      if (card) {
        solicitudEnviar.payment_method_client_id = card.id;
      }
      const reCaptchaToken = await executeRecaptcha('form/firmar');
      await instanceRef.instance.post(`form/firmar?token=${tokenForRequests}`, {
        ...solicitudEnviar,
        reCaptchaToken
      });

      await getSolicitud('actualizado');
      setSolicitando(false);
      setLoading(false);
      // scrollTop();
    } catch (error) {
      setSolicitando(false);
      setLoading(false);
      message.error('No se pudo enviar la solicitud');
    }
  };

  const getSolicitud = async (origen) => {
    const fullPath = location.pathname;
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `solicitud/token/${props.match.params.token}?fullPath=${fullPath}`
      );
      if (response.data && response.data.data) {
        const isFirmarPublico = fullPath.includes('firmar-publico/');
        const isFirmarSms = fullPath.includes('firmar-sms/');
        const isGenerarPublico = fullPath.includes('generar-cv-publico/');
        if (isFirmarPublico || isFirmarSms || isGenerarPublico) {
          setTokenForRequests(response.data.data.token);
        } else {
          setTokenForRequests(props.match.params.token);
        }
        if (origen === 'inicial' && response.data.data.estado !== 'PENDIENTE') {
          // setSolicitudEnCurso(false);
          setLoading(false);
        }

        const idProducto = response.data.data.cotizacion?.id_producto;
        setSolicitud(response.data.data);
        updateProducto(idProducto);
        setLoading(false);
        setEstado(response.data.data.estado);
        setMetodoPago(response.data?.data?.metodoPago);

        if (
          response.data.data.cotizacion?.persona?.id_cliente &&
          response.data.data.metodoPago?.codigo === 'tarjeta' &&
          response.data.data !== 'FINALIZADO'
        ) {
          await setIdClienteLastCard(
            response.data.data.cotizacion.persona.id_cliente
          );
        }
      } else {
        message.error('No se ha encontrado la solicitud');
        setLoading(false);
      }
    } catch (error) {
      errorHandler(error, 'No se pudo obtener la solicitud');
      setLoading(false);
      if (error.response && error.response.status === 400) {
        history.push(
          `/regenerar-token?flujo=solicitud&tokenExpirado=${props.match.params.token}`
        );
      }
    }
  };

  useEffect(() => {
    getSolicitud('inicial');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LogosEmpresaAseguradora />
      <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
        <ResponsiveContainer>
          <Card>
            <>
              <div ref={myRef} />
              {solicitud && estado === 'PENDIENTE' && metodoPago && (
                <>
                  <Form
                    name="firma"
                    initialValues={{}}
                    onFinish={solicitar}
                    scrollToFirstError
                    form={form}
                    layout="vertical"
                    autoComplete="off"
                  >
                    {metodoPago.codigo === 'tarjeta' ? (
                      <PagosCartaVerdeForm
                        card={card}
                        setCard={setCard}
                        solicitud={solicitud}
                        loading={loading}
                        solicitando={solicitando}
                        idClienteLastCard={idClienteLastCard}
                        setErrorCatastro={setErrorCatastro}
                      />
                    ) : (
                      <Result
                        status="success"
                        title="Pago por transferencia"
                        subTitle=""
                      />
                    )}

                    <br />

                    <Space>
                      <Tooltip title="">
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={
                            (!card || errorCatastro) &&
                            metodoPago.codigo === 'tarjeta'
                          }
                          loading={loading || solicitando}
                        >
                          Generar Carta Verde
                        </Button>
                      </Tooltip>
                    </Space>
                  </Form>
                </>
              )}

              {solicitud &&
                (estado === 'VERIFICAR' ||
                  estado === 'PROCESANDO' ||
                  estado === 'FINALIZADO') && (
                  <div style={styles.content}>
                    <Result
                      status="success"
                      title="Su Carta Verde se encuentra en proceso de emisión, en minutos recibirá el enlace con su póliza y factura por e-mail y SMS. ¡Muchas gracias!"
                    />
                  </div>
                )}
            </>
          </Card>
        </ResponsiveContainer>
      </Spin>
    </>
  );
};

export default GenerarPolizaCartaVerde;
